/* eslint-disable no-nested-ternary */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Dropdown, Button } from 'antd-v5';
import { CheckCircleOutlined, LoadingOutlined, ShoppingOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CollectionProductCard from '../CollectionProductCard';
import './styles.css';
import ProductsV2Container from '../../../../../ProductsV2/components/Container';

const CollectionProductsList = ({
  setSelectedProduct,
  collection,
  toggleShowAddProduct,
  showAddProduct,
  selectedProducts,
  toggleProductSelection,
  handleOpenProductPage,
  vendors,
  isFetchingVendors,
  openAttachmentUploadModal,
  type,
  loading,
  collectionProducts,
  fetchCollectionProducts,
  ...props
}) => {
  const flags = useFlags();
  const selectedFilter = useMemo(() => {
    switch (type) {
      case 'product-all':
        return 'allProducts';
      case 'product-in-stock':
        return 'inStockProducts';
      default:
        return type.split('-')[0] === 'brands' ? type.split('-')[1] : 'allProducts';
    }
  }, [type]);

  const productItems = useMemo(() => {
    const vendorItems = vendors?.length > 0 ? [{
      key: 'brands',
      type: 'group',
      label: 'Brands',
      children: vendors?.map(brand => ({
        key: brand.id,
        label: brand.name,
        onClick: () => handleOpenProductPage(`brands-${brand.id}`),
      })),
    }] : [];

    return [
      {
        key: 'product',
        type: 'group',
        label: 'Inventory',
        children: [
          {
            key: 'product-all',
            label: 'All Products',
            icon: <ShoppingOutlined />,
            onClick: () => handleOpenProductPage('product-all'),
          },
          {
            key: 'product-in-stock',
            label: 'In Stock',
            icon: <CheckCircleOutlined />,
            onClick: () => handleOpenProductPage('product-in-stock'),
          },
        ],
      },
      ...vendorItems,
    ];
  }, [vendors]);

  return (
    <div className="clients-v2-collection-products--list">
      <div style={{ ...props.listItemsStyles }} className="clients-v2-collection-products--list-items scrollbar-y">
        {loading && <div className="clients-v2-collection-products--list-subtitle">Loading...</div>}

        {!loading && showAddProduct ? (
          <div className="flex-row w-100-P">
            <ProductsV2Container
              vendors={vendors}
              selectedFilter={selectedFilter}
              listStyle={{ padding: '0 20px 0 0' }}
              isClientPage
              selectedProducts={selectedProducts}
              toggleProductSelection={toggleProductSelection}
              selectedAndDisabledProducts={new Set(collectionProducts.map(a => a.id))}
            />
          </div>
        ) : (collectionProducts.length > 0) ? (
          <>
            {collectionProducts?.map(item => (
              <CollectionProductCard key={item.id} product={item} onClick={() => setSelectedProduct(item)} />
            ))}
          </>
        ) : (
          <div className="w-100-P flex-col-center" style={{ height: '50%' }}>
            <p>This collection is empty</p>
            <div className="flex-row-spaceevenly-nowrap w-100-P">
              <div>
              <Dropdown
                trigger={['click']}
                arrow
                menu={{
                  style: {
                    width: '200px',
                  },
                  items: productItems,
                }}
              >
                <Button
                  type="primary"
                  icon={<FontAwesomeIcon icon="far fa-plus" className="m-right-5" />}
                  size="large"
                style={{ backgroundColor: '#E6F4FF', color: '#33AAFC' }}
                >
                  Add Products
                </Button>
              </Dropdown>
              </div>
              <div>

              {flags.files && <Button
                style={{ backgroundColor: '#E6F4FF', color: '#33AAFC' }}
                type="primary"
                icon={<FontAwesomeIcon icon="far fa-paperclip" className="m-right-5"/>}
                onClick={() => openAttachmentUploadModal()}
                size="large"

              >
                Attach Media

              </Button>}
              </div>

            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CollectionProductsList;
